module.exports = __webpack_public_path__ + "static-portal/img/custom-hy.b7e6c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-hy.jpg
// module id = K7rP
// module chunks = 4